import axios from 'axios'
import { getBaseUrl } from '../../config/config_dev'
export const instance = axios.create({
  timeout: 30000,
  baseURL: getBaseUrl()
})

